import React, { useState } from "react";
import ReactDOM from "react-dom";

import { useDispatch, useSelector } from "react-redux";
import { useRouteNode, Link } from "react-router5";
import SearchContact from "./searchBar/searchContact";
import SearchEntities from "./searchBar/searchEntities";
import SearchPostFeed from "./searchBar/searchPostFeed";
import SearchThemes from "./searchBar/searchThemes";
import TendancesTab from "./tendances/tendances_tab";
import SetProfil from "./contacts/contactProfil";
import Tab from "../components/tab/tab";
import { FilterDays, FilterContainer } from "../components/filter/filter";
import { getTrendingAll } from "../api";
import { getTrending } from "../redux/tendances/tendanceSlice";
import { useTranslation } from "react-i18next";

import "./style/explore.css";
import "./style/explore_list.css";
import "./style/search_bar.css";
import "../components/tab/tab.css";

const EntityLinkFactory = ({ id, children }) => {
  return (
    <Link
      routeName={"explore.entity"}
      routeOptions={{ reload: false }}
      routeParams={{ id: id }}
      key={id}
    >
      {children}
    </Link>
  );
};

const ContactLinkFactory = ({ id, children }) => {
  return (
    <Link
      routeName={"explore.contact"}
      routeOptions={{ reload: false }}
      routeParams={{ id: id }}
      key={id}
    >
      {children}
    </Link>
  );
};

const Explore = ({ portal_ref }) => {
  const { route } = useRouteNode("explore");
  console.log(route);
  const { t } = useTranslation();
  // explore.params
  const tabContent = [
    { title: "Contenus", root: "explore.content" },
    { title: "Contacts", root: "explore.contacts" },
    { title: "Entités", root: "explore.entities" },
    { title: "Thèmes", root: "explore.themes" },
  ];
  let { data, name } = route;

  name = name === "explore" ? "explore.content" : name;

  let view, container;

  const [buttonFilter, setButtonFilter] = useState(false);
  const [dataTrending, setDataTrending] = useState([]);
  const [init, setInit] = useState(false);
  const tendance = useSelector((state) => state.tendance.value);
  const dispatch = useDispatch();

  function setDuration(number) {
    dispatch(getTrending(number));
    getTrendingAll(number).then(setDataTrending);
  }

  function setFilter() {
    setButtonFilter(!buttonFilter);
  }

  if (!init) {
    setInit(true);
    getTrendingAll(tendance).then(setDataTrending);
  }

  const [search, setSearch] = React.useState("");
  const [search_theme, setSearchTheme] = [search, setSearch];
  // const [search_theme, setSearchTheme] = React.useState("");

  // HERE
  if (name === "explore.contacts") {
    view = (
      <SearchContact
        dataList={data.contacts}
        LinkFactory={ContactLinkFactory}
        search={search}
        setSearch={setSearch}
      />
    );
  } else if (name === "explore.entities") {
    view = (
      <SearchEntities
        dataList={data.entities}
        LinkFactory={EntityLinkFactory}
        search={search}
        setSearch={setSearch}
      />
    );
  } else if (name === "explore.themes") {
    view = (
      <SearchThemes
        dataList={data.themes}
        focus={data.focus_theme}
        search={search_theme}
        setSearch={setSearchTheme}
      />
    );
  } else if (name === "explore.content") {
    view = (
      <SearchPostFeed
        users={data.users}
        dataList={data.post_list}
        bookmarksInit={data.bookmarks}
        cursorInit={data.cursor}
        search={search}
        setSearch={setSearch}
      />
    );
  }

  let parent_route_name = name.split(".").slice(0, 2).join(".");

  if (parent_route_name === "explore.contact") {
    container = <SetProfil data={data.contact} type={"contact"} />;
  } else if (parent_route_name === "explore.entity") {
    container = <SetProfil data={data.entity} type={"entity"} />;
  } else if (parent_route_name === "explore.theme") {
    container = <SetProfil data={data.theme} type={"theme"} />;
  } else {
    container = (
      <>
        {portal_ref.current &&
          ReactDOM.createPortal(
            <FilterContainer>
              <FilterDays value={tendance} set={setDuration} />
            </FilterContainer>,
            portal_ref.current,
          )}
        <div className="c-container_global">
          {/*container-global*/}
          <section className="c-container container_one">
            {/*container 1*/}
            <div className="c-container_menu">
              <Tab active={tabContent.map((x) => x.root).indexOf(name)}>
                {tabContent.map((tab, idx) => (
                  <Tab.TabPane
                    key={`Tab-${idx}`}
                    tab={tab.title}
                    root={tab.root}
                  ></Tab.TabPane>
                ))}
              </Tab>
            </div>{" "}
            {/*menu  Tabs */}
            {view}
          </section>
          <section className="c-container container_two">
            {/*container 2*/}
            <p className="c-container_two-title title">{t("Tendances")}</p>
            {/*menu  Tabs*/}
            <div className="c-container_tendance">
              {/*container tabs*/}
              <TendancesTab
                setFilter={setFilter}
                contact={dataTrending.length === 0 ? [] : dataTrending.contact}
                entity={dataTrending.length === 0 ? [] : dataTrending.entity}
                themes={dataTrending.length === 0 ? [] : dataTrending.theme}
                root={"explore"}
              />
            </div>
          </section>
        </div>
      </>
    );
  }

  return <>{container}</>;
};

export default Explore;
